/**
 * withdrawal.js — EU Directive 2023/2673 / Decreto-Lei n.º 24/2014
 * Sends customer + admin emails via EmailJS only (Shopify /contact is blocked by captcha).
 */
(function () {
  'use strict';

  var step1       = document.getElementById('wd-step-1');
  var step2       = document.getElementById('wd-step-2');
  var success     = document.getElementById('wd-success');
  var advanceBtn  = document.getElementById('wd-advance-btn');
  var backBtn     = document.getElementById('wd-back-btn');
  var form        = document.getElementById('wd-form');
  var submitBtn   = document.getElementById('wd-submit-btn');
  var errorsBox   = document.getElementById('wd-errors');
  var errorsList  = document.getElementById('wd-errors-list');
  var root        = document.getElementById('wd-root');

  if (!step1 || !step2 || !success || !form || !submitBtn) return;

  var FIELDS = [
    {
      id: 'wd-name',
      label: 'Nome completo',
      validate: function (v) { return v.trim().length >= 2; },
      msg: 'O nome completo é obrigatório.'
    },
    {
      id: 'wd-email',
      label: 'Endereço de email',
      validate: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); },
      msg: 'Introduza um endereço de email válido.'
    },
    {
      id: 'wd-order',
      label: 'Número de encomenda',
      validate: function (v) { return v.trim().length >= 1; },
      msg: 'O número de encomenda é obrigatório.'
    },
  ];

  function getEmailConfig() {
    if (!root) return null;
    return {
      publicKey: root.dataset.emailjsPublicKey || '',
      serviceId: root.dataset.emailjsServiceId || '',
      templateCustomer: root.dataset.emailjsTemplateCustomer || '',
      templateAdmin: root.dataset.emailjsTemplateAdmin || '',
      adminEmail: root.dataset.adminEmail || '',
      shopName: root.dataset.shopName || 'Quintas de Seia',
      shopUrl: root.dataset.shopUrl || '',
      logoUrl: root.dataset.logoUrl || '',
      returnAddress: root.dataset.returnAddress || '',
      adminOrdersUrl: root.dataset.adminOrdersUrl || ''
    };
  }

  function isEmailConfigured(cfg) {
    return !!(cfg && cfg.publicKey && cfg.serviceId && cfg.templateCustomer && cfg.templateAdmin && cfg.adminEmail);
  }

  function showStep(next, prev) {
    prev.hidden = true;
    next.hidden = false;
    next.focus();
    next.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function showErrors(messages) {
    errorsList.innerHTML = messages.map(function (msg) {
      return '<li>' + msg + '</li>';
    }).join('');
    errorsBox.hidden = false;
    errorsBox.focus();
  }

  function emailJsErrorMessage(err) {
    if (!err) return '';
    if (typeof err.text === 'string' && err.text) return err.text;
    if (typeof err.message === 'string' && err.message) return err.message;
    return '';
  }

  if (advanceBtn) {
    advanceBtn.addEventListener('click', function () {
      showStep(step2, step1);
      if (window.FormSpamGuard) {
        FormSpamGuard.markFormReady(form);
      }
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      errorsBox.hidden = true;
      showStep(step1, step2);
    });
  }

  function validateForm() {
    var errors = [];
    var firstInvalid = null;

    FIELDS.forEach(function (cfg) {
      var el = document.getElementById(cfg.id);
      if (!el) return;

      var errWrap = document.getElementById(cfg.id + '-err');
      var errText = errWrap ? errWrap.querySelector('.wd-field-err__text') : null;

      if (!cfg.validate(el.value)) {
        errors.push(cfg.msg);
        el.setAttribute('aria-invalid', 'true');
        if (errWrap) {
          if (errText) errText.textContent = cfg.msg;
          errWrap.hidden = false;
        }
        if (!firstInvalid) firstInvalid = el;
      } else {
        el.removeAttribute('aria-invalid');
        if (errWrap) errWrap.hidden = true;
        if (errText) errText.textContent = '';
      }
    });

    return { valid: errors.length === 0, errors: errors, firstInvalid: firstInvalid };
  }

  FIELDS.forEach(function (cfg) {
    var el = document.getElementById(cfg.id);
    if (!el) return;
    el.addEventListener('input', function () {
      if (cfg.validate(el.value)) {
        el.removeAttribute('aria-invalid');
        var errWrap = document.getElementById(cfg.id + '-err');
        if (errWrap) errWrap.hidden = true;
      }
    });
  });

  function buildBody(data) {
    var separator = '──────────────────────────────────────────';
    return [
      '[LIVRE RESOLUÇÃO] — Pedido de Livre Resolução do Contrato',
      separator,
      'Nome:                    ' + data.name,
      'Email:                   ' + data.email,
      'Número de encomenda:     ' + data.order,
      data.reason ? 'Motivo (opcional):       ' + data.reason : '',
      separator,
      'Submetido em:            ' + data.submittedAt,
      '',
      'Este pedido foi submetido ao abrigo do Decreto-Lei n.º 24/2014',
      'e da Diretiva 2023/2673/UE (artigo 11.º-A).',
    ].filter(function (line) { return line !== ''; }).join('\n');
  }

  function addDays(dateStr, days) {
    var parts = dateStr.split('-');
    var d = new Date(
      parseInt(parts[0], 10),
      parseInt(parts[1], 10) - 1,
      parseInt(parts[2], 10)
    );
    d.setDate(d.getDate() + days);
    return d;
  }

  function fmtDate(d) {
    try {
      return d.toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch (e) {
      return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
    }
  }

  function populateSuccess(data) {
    var deadline = addDays((new Date()).toISOString().slice(0, 10), 14);
    setText('wd-s-name', data.name);
    setText('wd-s-email', data.email);
    setText('wd-s-order', data.order);
    setText('wd-s-deadline', fmtDate(deadline));
    setText('wd-s-submitted', data.submittedAt);
  }

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el) el.textContent = value || '—';
  }

  function collectFormData() {
    var nameEl = document.getElementById('wd-name');
    var emailEl = document.getElementById('wd-email');
    var orderEl = document.getElementById('wd-order');
    var reasonEl = document.getElementById('wd-reason');

    return {
      name: nameEl.value.trim(),
      email: emailEl.value.trim(),
      order: orderEl.value.trim(),
      reason: reasonEl ? reasonEl.value.trim() : '',
      submittedAt: (function () {
        try {
          return new Date().toLocaleString('pt-PT', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit', second: '2-digit'
          });
        } catch (e) {
          return new Date().toString();
        }
      }())
    };
  }

  function isDebugMode() {
    try {
      return new URLSearchParams(window.location.search).get('wd_debug') === '1';
    } catch (e) {
      return false;
    }
  }

  function logEmailPayload(label, serviceId, templateId, params) {
    if (!isDebugMode()) return;

    var snippet = 'emailjs.send("' + serviceId + '", "' + templateId + '", ' +
      JSON.stringify(params, null, 2) + ');';

    console.group('[Withdrawal] ' + label);
    console.log(snippet);
    console.table(params);
    console.groupEnd();
  }

  function ensureEmailJs(cfg) {
    if (typeof emailjs === 'undefined') {
      return Promise.reject(new Error('EmailJS SDK not loaded'));
    }
    emailjs.init({ publicKey: cfg.publicKey });
    return Promise.resolve();
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildWithdrawalAdminIntroHtml(data) {
    return '<p>O cliente <strong>' + escapeHtml(data.name) +
      '</strong> submeteu um pedido formal de livre resolução de contrato através da loja. ' +
      'Por favor, tome as ações necessárias com brevidade.</p>';
  }

  function buildWithdrawalAdminContentHtml(data, messageBody, adminOrdersUrl) {
    var name = escapeHtml(data.name);
    var email = escapeHtml(data.email);
    var order = escapeHtml(data.order);
    var submittedAt = escapeHtml(data.submittedAt);
    var reason = escapeHtml(data.reason || '—');
    var body = escapeHtml(messageBody);
    var ordersUrl = escapeHtml(adminOrdersUrl);

    return [
      '<table style="width:100%;border-collapse:collapse;margin:20px 0">',
      '<tr style="background:#f5f5f3">',
      '<td style="padding:10px 14px;font-weight:bold;width:40%">Assunto</td>',
      '<td style="padding:10px 14px">[LIVRE RESOLUÇÃO] Encomenda #' + order + '</td>',
      '</tr>',
      '<tr>',
      '<td style="padding:10px 14px;font-weight:bold">Nome do Cliente</td>',
      '<td style="padding:10px 14px">' + name + '</td>',
      '</tr>',
      '<tr style="background:#f5f5f3">',
      '<td style="padding:10px 14px;font-weight:bold">E-mail do Cliente</td>',
      '<td style="padding:10px 14px"><a href="mailto:' + email + '">' + email + '</a></td>',
      '</tr>',
      '<tr>',
      '<td style="padding:10px 14px;font-weight:bold">Data de submissão</td>',
      '<td style="padding:10px 14px">' + submittedAt + '</td>',
      '</tr>',
      '<tr style="background:#f5f5f3">',
      '<td style="padding:10px 14px;font-weight:bold">Motivo (opcional)</td>',
      '<td style="padding:10px 14px">' + reason + '</td>',
      '</tr>',
      '</table>',
      '<h3 style="color:#1a1a1a">Conteúdo do Pedido</h3>',
      '<div style="background:#f9f9f7;border-left:3px solid #af8101;padding:16px 20px;white-space:pre-wrap;font-size:14px">' + body + '</div>',
      '<h3 style="color:#c0392b">Ações Necessárias</h3>',
      '<ol style="line-height:1.8">',
      '<li>Se a encomenda <strong>ainda não foi expedida</strong>, cancele o envio imediatamente.</li>',
      '<li>Se a encomenda <strong>já foi expedida</strong>, aguarde a receção física dos artigos.</li>',
      '<li>Após verificação dos artigos devolvidos, processe o reembolso no prazo legal máximo de <strong>14 dias</strong>.</li>',
      '</ol>',
      ordersUrl ? (
        '<p style="margin-top:24px">' +
        '<a href="' + ordersUrl + '" style="background:#121212;color:#fff;padding:12px 24px;text-decoration:none;border-radius:3px;font-weight:bold">' +
        'Ver Encomendas no Shopify →</a></p>'
      ) : ''
    ].join('');
  }

  function buildWithdrawalAdminParams(cfg, data, messageBody) {
    return {
      to_email: cfg.adminEmail,
      customer_email: data.email,
      email_subject: 'Novo Pedido de Livre Resolução — Encomenda #' + data.order,
      form_title: '🔔 Novo Pedido de Livre Resolução',
      intro_html: buildWithdrawalAdminIntroHtml(data),
      content_html: buildWithdrawalAdminContentHtml(data, messageBody, cfg.adminOrdersUrl),
      shop_name: cfg.shopName
    };
  }

  function sendEmails(cfg, data, messageBody) {
    var customerParams = {
      to_email: data.email,
      contact_email: cfg.adminEmail,
      customer_name: data.name,
      order_number: data.order,
      submission_date: data.submittedAt,
      shop_name: cfg.shopName,
      return_address: cfg.returnAddress
    };

    var adminParams = buildWithdrawalAdminParams(cfg, data, messageBody);

    logEmailPayload('Customer email', cfg.serviceId, cfg.templateCustomer, customerParams);
    logEmailPayload('Admin email', cfg.serviceId, cfg.templateAdmin, adminParams);

    if (isDebugMode()) {
      console.warn(
        '[Withdrawal] wd_debug=1 — nenhum email enviado. ' +
        'Remove ?wd_debug=1 da URL para enviar a sério.'
      );
      return Promise.resolve({ debug: true });
    }

    return ensureEmailJs(cfg)
      .then(function () {
        return emailjs.send(cfg.serviceId, cfg.templateCustomer, customerParams);
      })
      .then(function () {
        return emailjs.send(cfg.serviceId, cfg.templateAdmin, adminParams);
      });
  }

  function handleSubmit() {
    var result = validateForm();
    if (!result.valid) {
      showErrors(result.errors);
      if (result.firstInvalid) result.firstInvalid.focus();
      return;
    }

    errorsBox.hidden = true;

    var cfg = getEmailConfig();
    if (!isEmailConfigured(cfg)) {
      showErrors(['O envio automático ainda não está configurado. Por favor contacte-nos por email.']);
      return;
    }

    var data = collectFormData();
    var messageBody = buildBody(data);

    if (window.FormSpamGuard && !isDebugMode()) {
      var spamCheck = FormSpamGuard.isBlocked(form, 'withdrawal');
      if (spamCheck.blocked) {
        if (spamCheck.silent) {
          populateSuccess(data);
          showStep(success, step2);
          return;
        }
        showErrors([spamCheck.message]);
        return;
      }
    }

    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-busy', 'true');

    sendEmails(cfg, data, messageBody)
      .then(function (result) {
        if (result && result.debug) {
          showErrors([
            'Modo debug: nenhum email foi enviado.',
            'Abra a consola do browser (F12 → Console) para ver os parâmetros exactos.',
            'Quando estiver tudo certo, remova ?wd_debug=1 da URL e submeta outra vez.'
          ]);
          return;
        }
        populateSuccess(data);
        showStep(success, step2);
        if (window.FormSpamGuard) {
          FormSpamGuard.markSubmitted('withdrawal');
        }
      })
      .catch(function (err) {
        console.error('[Withdrawal] Email send failed:', err);
        var detail = emailJsErrorMessage(err);
        var messages = [
          'Não foi possível enviar o pedido. Verifique os dados e tente novamente.',
          'Se o problema persistir, contacte-nos diretamente por email.'
        ];
        if (detail) messages.unshift(detail);
        showErrors(messages);
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-busy');
      });
  }

  submitBtn.addEventListener('click', handleSubmit);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
  });

}());
